import { internalActionKeys } from "../actions/internalActionKeys";
import { AnyAction } from "redux";
import { initialState } from "../store/initialState";
import { Reminder } from "src/common/types/reminder";

export default function internalRemindersReducer(
  state: Reminder[] = initialState.reminders,
  action: AnyAction
): Reminder[] {
  switch (action.type) {
    case internalActionKeys.GET_REMINDERS_SUCCESS:
      return action.reminders;
    case internalActionKeys.DELETE_REMINDER_SUCCESS: {
      // Remove the added reminder
      const deletedReminder: Reminder = action.reminders[0];
      const index = state.map(r => r.id).indexOf(deletedReminder.id);
      if (index >= 0) {
        return [...state.slice(0, index), ...state.slice(index + 1)];
      } else {
        return state;
      }
    }
    case internalActionKeys.SAVE_REMINDER_SUCCESS: {
      // Replace the updated or added reminder
      const savedReminder: Reminder = action.reminders[0];
      const index = state.map(r => r.id).indexOf(savedReminder.id);
      if (index >= 0) {
        return [...state.slice(0, index), savedReminder, ...state.slice(index + 1)];
      } else {
        return [...state, savedReminder];
      }
    }
    default:
      return state;
  }
}
